import React from 'react';
var HeaderServiceMi = function (_a) {
    var titre = _a.titre, baseline = _a.baseline;
    return (React.createElement("div", { className: "fr-header__service" },
        React.createElement("p", { className: "fr-header__service-title" }, titre),
        baseline ? (React.createElement("p", { className: "fr-header__service-tagline" }, baseline)) : null));
};
export default HeaderServiceMi;
